import { useEffect, useState } from "react";
import { Box, Button, TextField } from "@mui/material";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { DialogCore } from "src/Pages/components/DialogCore/DialogCore";
import { api } from "src/shared/setup/API/api";

interface IDefineProducerPasswordModal {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  producerId: string;
  onSuccess?: () => void;
}

export const DefineProducerPasswordModal = ({
  open,
  setOpen,
  producerId,
  onSuccess,
}: IDefineProducerPasswordModal) => {
  const { handleGetAlert } = useLayoutMainContext();
  const [loading, setLoading] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  useEffect(() => {
    if (!open) {
      setNewPassword("");
      setConfirmPassword("");
    }
  }, [open]);

  const handleSubmit = async () => {
    if (!newPassword.trim()) {
      handleGetAlert({ message: "Digite a nova senha" });
      return;
    }

    if (newPassword.trim().length < 6) {
      handleGetAlert({ message: "A senha deve ter no minimo 6 caracteres" });
      return;
    }

    if (newPassword !== confirmPassword) {
      handleGetAlert({ message: "As senhas nao conferem" });
      return;
    }

    setLoading(true);
    await api
      .patch(`/produtor/changePassword/${producerId}`, {
        senha: newPassword,
      })
      .then((res) => {
        handleGetAlert({ message: res.data.message || "Senha alterada com sucesso" });
        setOpen(false);
        onSuccess?.();
      })
      .catch((error) =>
        handleGetAlert({
          message: error?.response?.data?.message || "Erro ao definir nova senha",
        })
      )
      .finally(() => setLoading(false));
  };

  return (
    <DialogCore
      open={open}
      setOpen={setOpen}
      title="Definir nova senha do produtor"
      PaperProps={{ style: { width: "520px", maxWidth: "95%" } }}
    >
      <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 1.5 }}>
        <TextField
          label="Nova senha"
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          size="small"
          autoFocus
          fullWidth
        />
        <TextField
          label="Confirmar nova senha"
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          size="small"
          fullWidth
        />

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}>
          <Button variant="outlined" onClick={() => setOpen(false)} disabled={loading}>
            Cancelar
          </Button>
          <Button variant="contained" onClick={handleSubmit} disabled={loading}>
            Salvar senha
          </Button>
        </Box>
      </Box>
    </DialogCore>
  );
};
